import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { IWizardDataModelTemplate } from "../../../SinglePaymentTransferWizard/Models/WizardDataModelTemplate";
import { IncomePaymentDetails } from "./IncomePaymentDetails/IncomePaymentDetails";
import { FinancialAdvice } from "./FinancialAdvice";
import { Documents } from "./Documents";
import { Declaration } from "./Declaration";

interface IReviewProps extends IProcessComponentProps {
    type: SubAccountType;
    data: IWizardDataModelTemplate;
    extraInfo?: any;
}

interface IReviewState {
    hasChecked: any[];
}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = { hasChecked: [] };
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.isReview) {
            this.setState({ hasChecked: [1, 2] });
        }
    }

    isValid() {
        if (this.state.hasChecked.length < 2) {
            this.props.showErrorMsgPopUp(["You must accept all items to continue"], true);
        }
        return super.isValid() && this.state.hasChecked.length == 2;
    }

    handleChange(declarationIds: number[], isSelected: boolean) {
        const checked = this.state.hasChecked;
        if (isSelected) {
            declarationIds.length == 2
                ? this.setState({ hasChecked: declarationIds })
                : this.setState({ hasChecked: checked.concat(declarationIds) });
        } else {
            this.setState({ hasChecked: checked.filter((ele) => ele != declarationIds) });
        }
    }

    public render(): JSX.Element {
        const { data, extraInfo } = this.props;
        return (
            <div className="col-md-10 col-12">
                <h2>Review</h2>

                <div>
                    <Documents data={data} />
                    <FinancialAdvice data={data} />
                    <IncomePaymentDetails data={data} extraInfo={extraInfo} />
                    <Declaration
                        data={this.state.hasChecked}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={(declarationIds: number[], isSelected: boolean) => {
                            this.handleChange(declarationIds, isSelected);
                        }}
                    />
                </div>
            </div>
        );
    }
}
